module.exports = __webpack_public_path__ + "OpenSans-SemiBoldItalic.3263a9440baaa5ed99ef.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-SemiBoldItalic.woff2
// module id = ../../../../../src/assets/customfonts/OpenSans-SemiBoldItalic.woff2
// module chunks = styles